export default {
  methods: {
    generateToast(message, toastType) {
      // if (toastType == "success") {
      //   this.$bvToast.toast(`${message}`, {
      //     title: "Success",
      //     autoHideDelay: 8000,
      //     variant: "success",
      //     toaster: "b-toaster-top-center",
      //   });
      // } else {
      //   this.$bvToast.toast(`${message}`, {
      //     title: "Error",
      //     autoHideDelay: 10000,
      //     variant: "danger",
      //     toaster: "b-toaster-top-center",
      //   });
      this.$store.dispatch("showToast", {
        title: toastType == "success" ? "Success" : toastType == "error" ?"Error":"info",
        description: message,
        type: toastType == "success" ? "success" :toastType == "error"? "danger":"info",
        display: true,
      });
    },
  },
};
